import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import '../../Styles/OnboardingContainer.css'
import SelectRegulation from './SelectRegulation'
import RegulatoryTable from '../Governance/Components/RegulatoryTable'
import RegulatoryBodyDrawer from '../Governance/RegulatoryBodyDrawer'
import { useGovernanceStore } from 'src/Containers/Onboarding/Store/GovernanceStore'
import * as RoutePath from '../../Entities/RoutePath'
import { useOnboardingStore } from 'src/Containers/Onboarding/Store/OnboardingStore'
import { useLocation } from 'react-router'
import { Pagination, Typography } from '@mui/material'

const RegulationList = ({ reset, regulationListData, setRegulationListData, setShowSubmitButton }) => {
    const [ isSelectRegulation, setIsSelectRegulation ] = useState(false)
    const [ isSelectCompliance, setIsSelectCompliance ] = useState(false)
    const [ currentPage, setCurrentPage ] = useState(1)
    const [ editData, setEditData ] = useState([])
    const routePath = '/GRC' + RoutePath.GOVERNANCE.COMPLIANCE + '-' + RoutePath.GOVERNANCE.SETUP
    const [ tableBody, setTableBody ] = useState([])
    const [ editState, setEditState ] = useState({ right: false })
    const [ editNode, setEditNode ] = useState({})
    const selectOrgRegulation = useGovernanceStore(state => state.selectOrgRegulation) //
    const getSelectedRegulation = useGovernanceStore(state => state.getSelectedRegulations) //
    const getOrgRegulation = useOnboardingStore((state) => state.getOrgRegulation) //
    const getOrgRegData = useOnboardingStore(state => state.getOrgRegulationData)

    const { selectedRegulations } = useGovernanceStore()
    const [ data, setData ] = useState()
    const orgId = localStorage.getItem('orgId')
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const bodyType = queryParams.get('bodyType')
    const userId = localStorage.getItem('userId')

    useEffect(() => {
        getSelectedRegulation(orgId, bodyType)
    }, [ location.pathname, bodyType ])
    useEffect(() => {
        if (selectedRegulations.length > 0) {
            const getdata = selectedRegulations?.map(item => {
                item.bodyType = 'regulatory'
                return item
            })
            const findAcBodyType = getdata
            setRegulationListData(findAcBodyType)
        }
    }, [selectedRegulations])
    useEffect(() => {
        setData(getOrgRegData)
    }, [ getOrgRegData, bodyType ])
    useEffect(() => {
        if (data?.length > 0) {
            setTableBody(data)
            setShowSubmitButton(true)
            data.forEach(item => {
                if (!item.regulation || !checkMandatoryFields(item.raciiMatrices)) {
                    setShowSubmitButton(false)
                }
                return item
            })
        } else {
            setTableBody(data)
            setShowSubmitButton(false)
        }
    }, [ data, bodyType ])
    const isFieldMandatory = (field) => {
        return field &&
            field?.department !== '' &&
            field?.role !== ''
    }
    const checkMandatoryFields = (data) => {
        return data.every(item => isFieldMandatory(item))
    }

    const handleApplyRegulationList = async () => {
        setIsSelectRegulation(false)
        await selectOrgRegulation(editData, orgId, userId)
        getOrgRegulation(orgId, userId, bodyType)
        getSelectedRegulation(orgId, bodyType)
        setShowSubmitButton(true)
    }
    const handleEditClick = (item) => {
        setEditNode(item)
        setEditState({ right: true })
        reset()
    }
    const formatCount = count => String(count).padStart(2, '0')

    const handleCancelRegulationList = () => {
        setRegulationListData(regulationListData?.map((el) => {
            return { ...el, isChecked: false }
        }))
        setIsSelectRegulation(false)
    }
    const rowsPerPage = 5
    const [ totalPages, setTotalPages ] = useState(Math.ceil(tableBody?.length / rowsPerPage))
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }
    const [ entries, setEntries ] = useState({
        entry: 0,
        from: 0,
        to: 0
    })
    return (
        <div className='flex flex-col h-full'>
            {/* {tableBody?.length === 0 &&
                <Button className="m-auto" onClick={() => setIsSelectRegulation(true)}><FaRectangleList size={24} /><span className='pl-2'>{t('Select Regulation(s)')}</span></Button>} */}
            <SelectRegulation setEditData={setEditData} regulationListData={regulationListData} setRegulationListData={setRegulationListData} isSelectRegulation={isSelectRegulation} setIsSelectRegulation={setIsSelectRegulation} formatCount={formatCount} handleApplyRegulationList={handleApplyRegulationList} handleCancelRegulationList={handleCancelRegulationList} />
            <SelectRegulation setEditData={setEditData} regulationListData={regulationListData} setRegulationListData={setRegulationListData} isSelectRegulation={isSelectCompliance} setIsSelectRegulation={setIsSelectCompliance} formatCount={formatCount} handleApplyRegulationList={handleApplyRegulationList} handleCancelRegulationList={handleCancelRegulationList} />
            <RegulatoryTable setTotalPages={setTotalPages} setEntries={setEntries} checkbox={true} routePath={routePath} onboard={true} setIsSelectRegulation={setIsSelectRegulation} setIsSelectCompliance={setIsSelectCompliance} regulationTableData={tableBody} handleEditClick={handleEditClick} currentPage={currentPage} setCurrentPage={setCurrentPage} />
            {tableBody?.length > 0 && <div className="flex items-center justify-between mt-2">
                <Typography className="text-muted !text-h4">
                        Showing data {entries.from} to {entries.to} of {entries.entry} entries
                </Typography>
                <Pagination sx={{ marginLeft: 'auto' }}
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    variant="outlined"
                    shape="rounded"
                />
            </div>}
            <RegulatoryBodyDrawer
                onboard={true}
                setEditState={setEditState}
                setEditNodes={setEditNode}
                editState={editState}
                getState={editNode}
                setShowSubmitButton={setShowSubmitButton}
            />
        </div>
    )
}

RegulationList.propTypes = {
    regulationTableData: PropTypes.array,
    setRegulationTableData: PropTypes.func,
    regulationListData: PropTypes.array,
    setRegulationListData: PropTypes.func,
    setShowSubmitButton: PropTypes.func,
    reset: PropTypes.func
}

export default RegulationList
